// Source coordinates and degrees. Presentation only; authoritative state is never extrapolated.
const interpolationDelayMs = 200;

export function interpolateTransform(samples, renderTime) {
    if (!samples?.length) return null;
    let a = samples[0], b = null;
    for (const sample of samples) {
        if (sample.time <= renderTime) a = sample;
        else { b = sample; break; }
    }
    if (!b || a === b) {
        const seconds = Math.max(0, Math.min(100, renderTime - a.time)) / 1000;
        return { position: a.position.map((v, i) => v + a.velocity[i] * seconds), angles: [...a.angles] };
    }
    const seconds = (b.time - a.time) / 1000;
    const distance = Math.hypot(...b.position.map((v, i) => v - a.position[i]));
    const expected = Math.max(Math.hypot(...a.velocity), Math.hypot(...b.velocity)) * seconds;
    if (b.discontinuity || distance > Math.max(128, expected * 3 + 32))
        return { position: [...a.position], angles: [...a.angles] };
    const fraction = Math.max(0, Math.min(1, (renderTime - a.time) / (b.time - a.time)));
    return {
        position: a.position.map((v, i) => v + (b.position[i] - v) * fraction),
        angles: a.angles.map((v, i) => v + ((((b.angles[i] - v) % 360) + 540) % 360 - 180) * fraction),
    };
}

export class LiveTimeline {
    constructor() { this.reset(); }
    reset() { this.offset = null; this.lastSample = 0; this.lastArrival = 0; }
    observe(serverTime, localTime) {
        if (this.offset !== null && serverTime <= this.lastSample) return;
        const observed = localTime - serverTime;
        // Follow falling latency promptly, rising latency slowly. This does not require NTP.
        this.offset = this.offset === null ? observed : Math.min(observed, this.offset + (observed - this.offset) * 0.05);
        this.lastSample = serverTime; this.lastArrival = localTime;
    }
    animationTime(localTime) {
        return this.offset === null ? 0 : Math.min(localTime - this.offset - interpolationDelayMs, this.lastSample + 5000);
    }
    time(localTime) {
        if (this.offset === null) return 0;
        return Math.min(localTime - this.offset - interpolationDelayMs, this.lastSample + 100);
    }
}
